(function () {

    /* ================================
    CUSTOM DRAWER BEHAVIOUR si NOT DRAWER
  ================================ */

  (function () {
    function updateSearchDrawerState() {
      const header = document.querySelector('header.header');
      if (!header || !header.classList.contains('search-not-drawer')) return;

      const searchDrawer = document.querySelector('search-drawer.search-drawer');
      if (!searchDrawer) return;

      if (window.innerWidth > 1023) {
        if (!searchDrawer.hasAttribute('open')) {
          searchDrawer.setAttribute('open', '');
        }
        searchDrawer.setAttribute('aria-hidden', 'true');
      } else {
        if (searchDrawer.hasAttribute('open')) {
          searchDrawer.removeAttribute('open');
        }
        searchDrawer.setAttribute('aria-hidden', 'false');
      }
    }

    window.addEventListener('resize', updateSearchDrawerState);
    document.addEventListener('DOMContentLoaded', updateSearchDrawerState);

    updateSearchDrawerState();
  })();


  /* ================================
     HEADER SHRINK (inchangé)
  ================================ */

  const header = document.querySelector(
    ".shopify-section-group-header-group.cc-header"
  );
  const THRESHOLD = 500;
  let ticking = false;

  function getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function shrinkHeader(scrollTop) {
    if (!header) return;
    header.classList.toggle("shrink", scrollTop >= THRESHOLD);
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(() => {
        shrinkHeader(getScrollTop());
        ticking = false;
      });
    }
  }

  window.addEventListener("load", () => {
    shrinkHeader(getScrollTop());
    window.addEventListener("scroll", onScroll, { passive: true });
  });

 /* ================================
   PACKAGING RADIO + TEXTAREA
   (Alchemy AJAX safe)
================================ */

console.log("✅ Script packaging chargé");

const MIN_PACKAGING_CHARS = 5;

/* 🔍 Helper : récupérer les éléments à chaque fois */
function getPackagingElements() {
  return {
    textarea: document.getElementById("packaging-repartition"),
    repartitionBlock: document.querySelector(".packaging_repartition"),
    message: document.getElementById("message"),
    selectedRadio: document.querySelector(
      'input[name="attributes[Type d\'emballage souhaité]"]:checked'
    ),
    form:
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form form') ||
      document.querySelector('form'),
    submitButtons: document.querySelectorAll(
      'button[name="add"], button[name="checkout"], form[action*="/cart/add"] button[type="submit"]'
    )
  };
}

/* ================================
   ERROR MESSAGE
================================ */
function showPackagingError() {
  const { message } = getPackagingElements();
  if (!message) return;
  message.classList.add("is-visible");
}

function hidePackagingError() {
  const { message } = getPackagingElements();
  if (!message) return;
  message.classList.remove("is-visible");
}

/* ================================
   VALIDATION
================================ */
function isPackagingSeparateSelected() {
  const { selectedRadio } = getPackagingElements();
  return !!(selectedRadio && selectedRadio.value === "Séparément");
}

function getPackagingTextareaLength() {
  const { textarea } = getPackagingElements();
  if (!textarea) return 0;
  return textarea.value.trim().length;
}

function isPackagingTextareaValid() {
  return getPackagingTextareaLength() >= MIN_PACKAGING_CHARS;
}

function isPackagingFormValid() {
  if (!isPackagingSeparateSelected()) return true;
  return isPackagingTextareaValid();
}

/* ================================
   TOGGLE DISPLAY + RESET TEXTAREA
================================ */
function toggleRepartition() {
  const { textarea, repartitionBlock } = getPackagingElements();
  if (!repartitionBlock) return;

  if (isPackagingSeparateSelected()) {
    repartitionBlock.classList.add("is-visible");
  } else {
    repartitionBlock.classList.remove("is-visible");
    hidePackagingError();

    if (textarea && textarea.value.trim() !== "") {
      textarea.value = "";

      const data = new FormData();
      data.append("attributes[Répartition des emballages]", "");

      fetch("/cart/update.js", {
        method: "POST",
        body: data
      });
    }
  }
}

/* ================================
   CHECK LIVE TEXTAREA
================================ */
function handlePackagingTextareaInput() {
  if (!isPackagingSeparateSelected()) {
    hidePackagingError();
    return;
  }

  if (isPackagingTextareaValid()) {
    hidePackagingError();
  } else {
    showPackagingError();
  }
}

/* ================================
   VALIDATION ON SUBMIT / CLICK
================================ */
function validatePackagingBeforeSubmit(event) {
  if (!isPackagingSeparateSelected()) {
    hidePackagingError();
    return true;
  }

  if (!isPackagingTextareaValid()) {
    event.preventDefault();
    event.stopPropagation();

    showPackagingError();

    const { textarea } = getPackagingElements();
    if (textarea) textarea.focus();

    return false;
  }

  hidePackagingError();
  return true;
}

/* ================================
   EVENTS INIT
================================ */
function initPackagingValidation() {
  const { textarea, form, submitButtons } = getPackagingElements();

  toggleRepartition();

  document.addEventListener("change", function (event) {
    const target = event.target;

    if (
      target &&
      target.matches('input[name="attributes[Type d\'emballage souhaité]"]')
    ) {
      toggleRepartition();
      hidePackagingError();
    }
  });

  if (textarea && !textarea.dataset.packagingBound) {
    textarea.addEventListener("input", handlePackagingTextareaInput);

    textarea.addEventListener("blur", function () {
      if (isPackagingSeparateSelected() && !isPackagingTextareaValid()) {
        showPackagingError();
      }
    });

    textarea.dataset.packagingBound = "true";
  }

  if (form && !form.dataset.packagingSubmitBound) {
    form.addEventListener("submit", validatePackagingBeforeSubmit);
    form.dataset.packagingSubmitBound = "true";
  }

  submitButtons.forEach((button) => {
    if (!button || button.dataset.packagingClickBound) return;

    button.addEventListener("click", validatePackagingBeforeSubmit);
    button.dataset.packagingClickBound = "true";
  });
}

/* Init */
document.addEventListener("DOMContentLoaded", initPackagingValidation);
document.addEventListener("shopify:section:load", initPackagingValidation);
document.addEventListener("shopify:section:reorder", initPackagingValidation);
document.addEventListener("shopify:section:select", initPackagingValidation);

  /* ================================
     UPDATE CART ATTRIBUTES + DEBUG
  ================================ */
  function updateAndLogCart() {
    const { textarea } = getPackagingElements();

    const selectedRadio = document.querySelector(
      "input[name=\"attributes[Type d'emballage souhaité]\"]:checked"
    );

    const data = new FormData();

    if (selectedRadio) {
      data.append(selectedRadio.name, selectedRadio.value);
    }

    if (textarea) {
      data.append(textarea.name, textarea.value);
    }

    fetch("/cart/update.js", {
      method: "POST",
      body: data
    })
      .then(() => fetch("/cart.js"))
      .then(res => res.json())
      .then(cart => {
        console.clear();
        console.log("🛒 Cart attributes LIVE:", cart.attributes);
      })
      .catch(err => console.error("❌ Cart error", err));
  }

  /* ================================
     ✅ EVENT DELEGATION (important)
     Works even after AJAX refresh
  ================================ */

  document.addEventListener("change", function (e) {

    /* Radios packaging */
    if (
      e.target.matches(
        "input[name=\"attributes[Type d'emballage souhaité]\"]"
      )
    ) {
      toggleRepartition();
      updateAndLogCart();
    }
  });

  document.addEventListener("input", function (e) {

    /* Textarea repartition */
    if (e.target.id === "packaging-repartition") {
      updateAndLogCart();
    }
  });

  /* ================================
     MUTATION OBSERVER (Alchemy AJAX)
     Re-run toggle after cart refresh
  ================================ */

  const cartContainer = document.querySelector("form[action='/cart']") || document.body;

  const observer = new MutationObserver(() => {
    toggleRepartition();
  });

  observer.observe(cartContainer, {
    childList: true,
    subtree: true
  });

  /* ================================
     INITIAL STATE
  ================================ */
  toggleRepartition();

})();